import { values } from 'lodash'
import {
  AlpsRecommendedAction,
  AlpsRecommendedActionDisplay,
  AlpsStatus,
  AlpsStatusDisplay,
  NsccStatus,
  NsccStatusDisplay,
  ProcessingDirection,
  ProcessingDirectionDisplay,
  RejectReason,
  RejectReasonDisplay,
  TransferType,
  TransferTypeDisplay,
} from '../../api/types'

export const ALPS_RECOMMENDED_ACTION_OPTIONS = values(
  AlpsRecommendedAction
).map(value => ({
  value,
  label: AlpsRecommendedActionDisplay[value],
}))
export const ALPS_STATUS_OPTIONS = values(AlpsStatus).map(value => ({
  value,
  label: AlpsStatusDisplay[value],
}))
export const NSCC_STATUS_OPTIONS = values(NsccStatus).map(value => ({
  value,
  label: NsccStatusDisplay[value],
}))
export const PROCESSING_DIRECTION_OPTIONS = values(ProcessingDirection).map(
  value => ({
    value,
    label: ProcessingDirectionDisplay[value],
  })
)
export const REJECT_REASON_OPTIONS = values(RejectReason).map(value => ({
  value,
  label: RejectReasonDisplay[value],
}))
export const TRANSFER_TYPE_OPTIONS = values(TransferType).map(value => ({
  value,
  label: TransferTypeDisplay[value],
}))
